@if (isVisible()) {
  <!-- To retrieve common data from the block, implements BlockCommonDataInterface in your block and the input: readonly common = input<BlockCommon>()-->
  <app-component-factory
    [data]="data"
    [componentClass]="$any(componentClass)"
    (isVisibleChanged)="isVisible.set($event)"
  ></app-component-factory>
}
